export default __webpack_public_path__ + "static/media/photo--sm--42.dbba0a28.jpg";